module.exports = __webpack_public_path__ + "img/traitement.6dccbe7d.png";